import {
  DAT_BIOLOGY_SUBJECTS,
  DAT_GCHEM_SUBJECTS,
  DAT_OCHEM_SUBJECTS,
  DAT_PAT_SUBJECTS,
  DAT_QR_SUBJECTS,
  DAT_RC_SUBJECTS,
  DAT_SECTIONS,
} from 'my-core/dat-tagging-system';
import { MCAT_SUBJECT_LIST } from 'my-core/mcat-data';
import { MCAT_SUBJECTS } from 'my-core/mcat-tagging-system';

/**
 * Tag field definitions shared between QuestionCustomTagsInput and ScoreScalesEditor.
 * Each entry: { key, label, values: [{ key, label }] }
 */

export function getCustomTagFieldOptions() {
  return [
    {
      key: 'mcat_section',
      label: 'MCAT Section',
      values: MCAT_SUBJECT_LIST.map(s => ({ key: s.key, label: s.short_name })),
    },
    {
      key: 'mcat_subject',
      label: 'MCAT Subject',
      values: MCAT_SUBJECTS.map(s => ({ key: s.key, label: s.abbrv })),
    },
    {
      key: 'dat_section',
      label: 'DAT Section',
      values: DAT_SECTIONS.map(s => ({ key: s.key, label: s.short_name })),
    },
    {
      key: 'dat_subject',
      label: 'DAT Subject',
      values: [
        ...DAT_BIOLOGY_SUBJECTS,
        ...DAT_GCHEM_SUBJECTS,
        ...DAT_OCHEM_SUBJECTS,
        ...DAT_PAT_SUBJECTS,
        ...DAT_RC_SUBJECTS,
        ...DAT_QR_SUBJECTS,
      ].map(s => ({ key: s.key, label: s.name })),
    },
  ];
}

export function matchesTagFilters(question, tagFilters) {
  if (!tagFilters) return true;
  return Object.entries(tagFilters).every(([key, expected]) => {
    const actual = getQuestionTag(question, key);
    return actual === expected;
  });
}

function getQuestionTag(question, fieldKey) {
  switch (fieldKey) {
    case 'mcat_section':
      return question.custom_tags?.mcat?.section;
    case 'mcat_subject':
      return question.custom_tags?.mcat?.subject;
    case 'dat_section':
      return question.custom_tags?.dat?.section;
    case 'dat_subject':
      return question.custom_tags?.dat?.subject;
  }
} /**
 * Given a raw score and a score matrix ([{ min_raw, score }, ...] sorted ascending by min_raw),
 * finds the last entry where min_raw <= rawScore and returns its score.
 */

export function lookupScaledScore(points, scoreMatrix) {
  if (!scoreMatrix?.length) return null;
  let result = null;
  for (const entry of scoreMatrix) {
    if (entry.min_raw > points) break;
    result = entry.score;
  }
  return result;
}
